import { render, staticRenderFns } from "./CarrouselInformativa.vue?vue&type=template&id=1947f570&scoped=true&"
import script from "./CarrouselInformativa.vue?vue&type=script&lang=ts&"
export * from "./CarrouselInformativa.vue?vue&type=script&lang=ts&"
import style0 from "./CarrouselInformativa.vue?vue&type=style&index=0&id=1947f570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947f570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1947f570', component.options)
    } else {
      api.reload('1947f570', component.options)
    }
    module.hot.accept("./CarrouselInformativa.vue?vue&type=template&id=1947f570&scoped=true&", function () {
      api.rerender('1947f570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/reusables/CarrouselInformativa.vue"
export default component.exports